export default function Pronostics() {
  return (
    <div className="h-screen w-full flex flex-col items-center justify-center">
      <div className="px-10 flex flex-col lg:flex-row-reverse md:max-w-6xl justify-between z-50">
        <div className="flex flex-col items-center lg:items-start justify-center lg:pt-[88px] w-full lg:w-1/2">
          <div className="flex flex-col space-y-5">
            <img
              className="lg:hidden w-96 rotate-12"
              alt="Pronostics"
              src="/img/assets/pronostics_functionality.webp"
            ></img>
            <p className="text-5xl font-bold">Pronostics</p>
            <p className="text-medium">
              Deux fois par jour recevez une liste de pronostics de combinaison
              de 4 numéros. Choisissez une combinaison et jouez là auprès de la
              Française des Jeux. Les combinaisons peuvent être filtrées selon
              vos préférences : Écart, Nombre de sortie, Numéros en forme.
            </p>
          </div>
        </div>
        <div className="hidden lg:flex lg:flex-col justify-center items-center lg:w-1/2">
          <img
            className="w-96 rotate-12"
            alt="Pronostics"
            src="/img/assets/pronostics_functionality.webp"
          ></img>
        </div>
      </div>
      <div
        className="hidden lg:block absolute h-full w-2/5 left-0 bg-gradient-to-tr from-primary to-secondary z-0"
        style={{ borderRadius: "60% 100% 100% 79% / 68% 88% 90% 100%" }}
      ></div>
    </div>
  );
}
